import {ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";

interface VisitPlanTableColumnSwitch {
  label: string;
  field: string;
  isActive: boolean;
}

require('./visit-plan-table-column-filter-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-table-column-filter-dialog',
  templateUrl: './visit-plan-table-column-filter-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanTableColumnFilterDialogComponent implements OnInit {


  @Output() onFilterSwitched = new EventEmitter<VisitPlanTableColumnSwitch>()

  public tableFilterColumns: VisitPlanTableColumnSwitch[];

  constructor(@Inject(PANEL_DATA) public data: { filters: VisitPlanTableColumnSwitch[] }) {
  }

  ngOnInit(): void {
    this.tableFilterColumns = this.data.filters;
  }

  toggleColumnFilter(column: VisitPlanTableColumnSwitch) {
    this.tableFilterColumns = this.tableFilterColumns.map(col => col.field === column.field ? {...col, isActive: !col.isActive} : col)
    this.onFilterSwitched.emit({...column, isActive: !column.isActive});
  }
}
